import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex items-center" }

import { useNotificationStore } from "@/store/notificationStore";
import CoreIcon from "./CoreIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationBubbles',
  setup(__props) {

const notificationStore = useNotificationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notificationStore).notifications, (notification, i) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "fixed w-full flex-col justify-center items-center pointer-events-none text-xs h-textarea",
      style: _normalizeStyle({
      top: `${i * 5 + 5}px`,
      'z-index': `${51 + i}`,
    }),
      key: i
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["max-w-sm mx-auto text-white p-4 rounded shadow border-lighten border flex justify-between pointer-events-auto", {
        'bg-red': notification.type == 'danger',
        'bg-orange': notification.type == 'warning',
        'bg-blue': notification.type == 'info',
        'bg-green': notification.type == 'success',
      }])
      }, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(notification.msg), 1),
        _createVNode(CoreIcon, {
          icon: notification.icon ?? 'close',
          white: "",
          onClick: ($event: any) => (
          notification.action
            ? notification.action()
            : _unref(notificationStore).notifications.splice(i, 1)
        )
        }, null, 8, ["icon", "onClick"])
      ], 2)
    ], 4))
  }), 128))
}
}

})